import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class HistoricoAlteracoesDataService extends CrudService<any> {

  protected url: string;

  private urlReplace: string;

  constructor(
    @Inject(OPERACAO_API_URL) urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.urlReplace = `${urlBase}/v1/historicoalteracoes/<parent>`;
  }
  
  public withParentId(id) {
    this.url = this.urlReplace.replace('<parent>', id);
    return this;
  }
}
